import React from 'react';
import { Box } from '@mui/material';

import { formatDate } from '@utils';
import { useAssignees } from '@hooks';
import { CardInfo } from 'components/common/ui';

import styles from './bookingLostError.style';

const DetailsItem = ({ label, value }) => (
  <>
    <Box sx={styles.label}>
      {label}
      <Box component="span" sx={styles.value}>
        :
      </Box>
    </Box>

    <Box sx={styles.value}>{value}</Box>
  </>
);

const BookingLostError = ({ booking, stages, lostReasonOptions }) => {
  const { getAssigneeName } = useAssignees();

  const reasonKey = booking?.lostDetails?.reason;

  const reason =
    lostReasonOptions?.find((option) => option.value === reasonKey)?.text ||
    reasonKey ||
    'N/A';

  const assignee = getAssigneeName(booking?.lostDetails?.createdBy);

  const date = formatDate(booking?.lostDetails?.createdAt, 'dd/MM/yyyy, HH:mm');

  const markedByText = `${assignee} on ${date}`;

  const stageAtLost =
    stages?.find((stage) => stage.value === booking?.stage)?.text || 'N/A';

  return (
    <Box sx={styles.wrapper}>
      <CardInfo type="error">
        <Box sx={styles.contentWrapper}>
          <Box sx={styles.title}>This booking is marked as Lost</Box>
          <Box sx={styles.detailsWrapper}>
            <DetailsItem label="Reason" value={reason} />
            <DetailsItem label="Marked by" value={markedByText} />
            <DetailsItem label="Stage at lost" value={stageAtLost} />
          </Box>
        </Box>
      </CardInfo>
    </Box>
  );
};

export default BookingLostError;
